
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useStore } from "../../../stores/store";
import { observer } from "mobx-react-lite";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { useEditData } from "../../../hooks/useEditData";
import FormLayout from '../../Generic/FormLayout';
import FormInput from '../../Generic/FormInput';
import FormCheckbox from '../../Generic/FormCheckbox';
import { useSetMenu } from "../../../hooks/useSetMenu";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import FormSelect from "../../Generic/FormSelect";
import useAuth from '../../../hooks/useAuth';

const Edit = () => {
  const { id } = useParams();
  const { auth } = useAuth();
  const navigate = useNavigate();
  const { mainStore } = useStore();
  const axiosPrivate = useAxiosPrivate();
  const { t } = useTranslation();
  useSetMenu(mainStore.UserMenuType, mainStore.UserMenuNo);
  const schema = yup.object({
    fullName: yup
    .string()
    .required(t('requiredField'))
    .max(50, t('maxLength', { max: 50 })),
  username: yup
    .string()
    .required(t('requiredField'))
    .max(50, t('maxLength', { max: 50 })),
  email: yup
    .string()
    .required(t('requiredField'))
    .max(50, t('maxLength', { max: 50 })),
  role : yup.string().required(t("selectRequired")),
  });

  const { register, handleSubmit, formState: { errors }, setValue } = useForm({ resolver: yupResolver(schema) });
  const onSubmit = data => {
    updateData(data);
  };
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const additionalDataFetch = async (userData) => {
    try {
      const rolesResponse = await axiosPrivate.get("/Roles/SelectOptions");
      setRoles(rolesResponse.data);
      const selected = rolesResponse.data.find(c => c.label === userData.role);
      setSelectedRole(selected);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleRoleChange = selectedOption => {
    setSelectedRole(selectedOption);
    setValue("role", selectedOption.label);
  };

  const { notFound, updateData } = useEditData(axiosPrivate, "/Users", id, setValue, navigate,additionalDataFetch);

  const goToList = () => {
    navigate("/User/List");
  };

  if (notFound) {
    return <div className="not-found-myDiv">
      <div className="not-found-container">
        <div className="not-found-content">
          <h1>{t("pageNotFoundTitle")}</h1>
          <p>{t("noDataWithIdMessage")}</p>
          <button onClick={goToList} className="btn btn-primary">
            {t("goTo") + " " + t("list") + " " + t("users")}
          </button>
        </div>
      </div>
    </div>;
  }

  return (
    <FormLayout title={t("userEditTitle")} onSubmit={handleSubmit(onSubmit)} onCancel={() => navigate(-1)}>
      <FormInput label="userFullName" name="fullName"  register={register} errors={errors} />
      <FormInput label="userUsername" name="username"  register={register} errors={errors} />
      <FormInput label="userEmail" name="email"  register={register} errors={errors} />
      <FormSelect label="userRole" name="role"  register={register} errors={errors} value={selectedRole} options={roles} onChange={handleRoleChange} />
      <FormCheckbox label="isActive" register={register} name="isActive" colSize={4} />
    </FormLayout>
  );
};

export default observer(Edit);